<template>
  <div>
    <div class="space-between align-center">
      <div class="align-center flex-1">
        <div class="filter-icon">
          <img src="/img/filter.svg" alt="" />
        </div>

        <div class="search-wrappper">
          <b-input-group size="sm">
            <b-form-input v-model="filter" placeholder="Search here...">
            </b-form-input>

            <b-input-group-append>
              <b-button @click="getUserList">
                Search
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>

      <button
        type="button"
        class="btn mulai btn-secondary font-bold"
        @click="handleNew"
      >
        <fa-icon icon="edit" class="my-icon" />&nbsp; ADD NEW USER
      </button>
    </div>
    <br />
    <br />
    <!-- Main table element -->
    <b-table
      show-empty
      stacked="md"
      :busy="isBusy"
      :items="items"
      :fields="fields"
      @sort-changed="sortingChanged"
    >
      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>

      <template #cell(actions)="row">
        <b-button
          size="sm"
          class="mr-3 action-button"
          variant="outline-secondary"
          @click="handleEdit(row.item)"
        >
          <fa-icon icon="pencil-alt" class="my-icon" />&nbsp;Edit
        </b-button>
        <b-button
          size="sm"
          class="mr-3 action-button"
          variant="outline-secondary"
          @click="handleEditEmail(row.item)"
        >
          <fa-icon icon="pencil-alt" class="my-icon" />&nbsp;Edit Email
        </b-button>
        <b-button
          size="sm"
          class="mr-3 action-button"
          variant="outline-secondary"
          @click="handleEditRole(row.item)"
        >
          <fa-icon icon="pencil-alt" class="my-icon" />&nbsp;Edit Role
        </b-button>
        <b-button
          size="sm"
          class="mr-3 action-button"
          variant="outline-secondary"
          @click="handleEditPassword(row.item)"
        >
          <fa-icon icon="pencil-alt" class="my-icon" />&nbsp;Change Password
        </b-button>
        <!-- <b-button
          size="sm"
          class="mr-3 action-button"
          variant="outline-danger"
          @click="handleDelete(row.item)"
        >
          <fa-icon icon="minus-circle" class="my-icon" />&nbsp;Delete
        </b-button> -->
      </template>
    </b-table>

    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
      <b-col md="6" class="my-1 text-right">
        <b>Total {{ totalRows }} user(s)</b>
      </b-col>
    </b-row>

    <b-modal
      v-model="addModal"
      id="addModal"
      hide-header
      hide-footer
      centered
      size="lg"
    >
      <modal-cross @close="addModal = false"></modal-cross>
      <div class="p-4">
        <h3 class="txt-center color2">{{editData ? "Edit User" : "Create New User"}}</h3>
        <br />

        <h3 v-if="editData">#ID {{ inputData.id }}</h3>

        <label>Email</label>
        <br />
        <b-form-input
          placeholder="Email"
          v-model="inputData.email"
          :readonly="!editEmail"
        ></b-form-input>
        <br />

        <div v-if="editData && !editEmail">
          <label>Mailing Email</label>
          <br />
          <b-form-input
            placeholder="Mailing Email"
            v-model="inputData.mailing_email"
          ></b-form-input>
          <br>
        </div>

        <div v-if="!(editData && editEmail)">
          <label>Name</label>
          <br />
          <b-form-input
            placeholder="Name"
            v-model="inputData.name"
          ></b-form-input>
          <br>

          <label>NIS</label>
          <br />
          <b-form-input
            placeholder="NIS"
            v-model="inputData.nis"
          ></b-form-input>
          <br>
        </div>

        <div class="justify-end">
          <my-button
            type="blue"
            disabled
            v-show="showLoading"
          >
            <b-spinner small></b-spinner>
            <span class="sr-only">Loading...</span>
          </my-button>
          <my-button
            type="blue"
            v-show="!showLoading"
            @click="handleSave"
          >
            SAVE
          </my-button>
        </div>
        <br />
      </div>
    </b-modal>

    <b-modal
      v-model="roleModal"
      id="roleModal"
      hide-header
      hide-footer
      centered
      size="lg"
    >
      <modal-cross @close="roleModal = false"></modal-cross>
      <div class="p-4">
        <h3 class="txt-center color2">Edit Role</h3>
        <br />

        <b-form-group label="User role:" v-slot="{ ariaDescribedby }">
          <b-form-checkbox-group
            id="checkbox-group-1"
            v-model="userRole"
            :options="roleList"
            :aria-describedby="ariaDescribedby"
            name="flavour-1"
          ></b-form-checkbox-group>
        </b-form-group>
        <br>

        <div class="justify-end">
          <my-button
            type="blue"
            disabled
            v-show="showLoading"
          >
            <b-spinner small></b-spinner>
            <span class="sr-only">Loading...</span>
          </my-button>
          <my-button
            type="blue"
            v-show="!showLoading"
            @click="handleSaveRole"
          >
            SAVE
          </my-button>
        </div>
        <br />
      </div>
    </b-modal>

    <b-modal
      v-model="passwordModal"
      id="passwordModal"
      hide-header
      hide-footer
      centered
      size="lg"
    >
      <modal-cross @close="passwordModal = false"></modal-cross>
      <div class="p-4">
        <h3 class="txt-center color2">Change Password</h3>
        <br />

        <label>New Password</label>
        <br />
        <b-form-input
          placeholder="Password"
          v-model="userPassword"
        ></b-form-input>
        <br />

        <div class="justify-end">
          <my-button
            type="blue"
            disabled
            v-show="showLoading"
          >
            <b-spinner small></b-spinner>
            <span class="sr-only">Loading...</span>
          </my-button>
          <my-button
            type="blue"
            v-show="!showLoading"
            @click="handleSavePassword"
          >
            SAVE
          </my-button>
        </div>
        <br />

      </div>
    </b-modal>

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  data() {
    return {
      addModal: false,
      editData: false,
      editEmail: false,
      isBusy: false,
      items: [],
      fields: [
        {
          key: "id",
          label: "#ID",
          sortable: true
        },
        {
          key: "email",
          label: "Email",
          sortable: true
        },
        {
          key: "name",
          label: "Name",
          sortable: true
        },
        {
          key: "mailing_email",
          label: "Mailing Email",
          sortable: true
        },
        {
          key: "nis",
          label: "NIS",
          sortable: true
        },
        {
          key: "actions",
          label: "Action"
        }
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 20,
      filter: null,
      sortBy: null,
      sortDesc: false,
      inputData: {
        id: 0,
        email: "",
        name: "",
        nis: ""
      },
      showLoading: false,
      roleModal: false,
      roleList: types.ROLE,
      userRole: [],
      passwordModal: false,
      userPassword: ""
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn"
    })
  },
  watch: {
    currentPage: function(newValue) {
      if (newValue) {
        this.getUserList();
      }
    }
  },
  created() {
    if (!this.isLoggedIn) {
      this.$router.push("/login");
    }
  },
  mounted() {
    this.getUserList();
  },
  methods: {
    ...mapActions({
      userList: types.USER_LIST,
      userDetail: types.USER_DETAIL,
      userCreate: types.USER_CREATE,
      userUpdate: types.USER_UPDATE,
      userUpdateEmail: types.USER_UPDATE_EMAIL,
      userUpdateRole: types.USER_UPDATE_ROLE,
      userUpdatePassword: types.USER_UPDATE_PASSWORD
    }),
    getUserList() {
      this.isBusy = true;
      var payload = {
        params: {
          offset: (this.currentPage - 1) * this.perPage,
          limit: this.perPage
        }
      }

      if(this.filter) {
        payload.params.search = this.filter;
      }

      if(this.sortBy) {
        payload.params.column = this.sortBy;
        payload.params.order = this.sortDesc ? 'DESC' : 'ASC';
      }

      this.userList(payload)
        .then(response => {
          this.items = response.user;
          this.totalRows = response.total;
          this.isBusy = false;
        })
        .catch(error => {
          this.showMessageBox(error, "Failed", "success");
        });
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = this.sortDesc;
      this.getUserList();
    },
    handleNew() {
      this.editData = false;
      this.editEmail = true;
      this.addModal = true;
      this.inputData = {
        id: 0,
        email: "",
        mailing_email: "",
        name: "",
        nis: ""
      }
    },
    handleEdit(item) {
      this.editData = true;
      this.editEmail = false;
      this.addModal = true;
      this.inputData = {
        id: item.id,
        email: item.email,
        mailing_email: item.mailing_email,
        name: item.name,
        nis: item.nis
      }
    },
    handleEditEmail(item) {
      this.editData = true;
      this.editEmail = true;
      this.addModal = true;
      this.inputData = {
        id: item.id,
        email: item.email,
        mailing_email: item.mailing_email,
        name: item.name,
        nis: item.nis
      }
    },
    handleEditRole(item) {
      this.userRole = [];
      this.inputData = item;

      var payload = {
        params: {
          id: item.id
        }
      }

      this.userDetail(payload)
      .then(response => {
        for (var i = 0; i < response.role.length; i++) {
          this.userRole.push(response.role[i].id);  
        }
        this.roleModal = true;
      })
      .catch(error => {
        this.showMessageBox(error, "Failed", "success");
      });
    },
    handleEditPassword(item) {
      this.userPassword = "";
      this.inputData = item;
      this.passwordModal = true;
    },
    handleSave() {
      if(this.editData && this.editEmail) {
        this.editUserEmail();
      } else if(this.editData) {
        this.editUser();
      } else {
        this.addUser();
      }
    },
    handleSaveRole() {
      if(this.userRole.length > 0) {
        this.showLoading = true;

        var payload = {
          id: this.inputData.id,
          role: this.userRole.join(",")
        }

        this.userUpdateRole(payload)
        .then(response => {
          this.showLoading = false;
          this.roleModal = false;
          this.showMessageBox("Data has been saved", "Success", "success");
        })
        .catch(error => {
          this.showLoading = false;
          this.showMessageBox(error, "Failed", "danger");
        });
      } else {
        this.showMessageBox("Please select a role first", "Empty Data", "warning");
      }
    },
    handleSavePassword() {
      if(this.userPassword) {
        this.showLoading = true;

        var payload = {
          id: this.inputData.id,
          password: this.userPassword
        }

        this.userUpdatePassword(payload)
        .then(response => {
          this.showLoading = false;
          this.passwordModal = false;
          this.showMessageBox("Data has been saved", "Success", "success");
        })
        .catch(error => {
          this.showLoading = false;
          this.showMessageBox(error, "Failed", "danger");
        });
      } else {
        this.showMessageBox("Please input new password first", "Empty Data", "warning");
      }
    },
    handleDelete(index) {
      this.$bvModal.msgBoxConfirm('Delete this data?', {
        title: 'Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if(value) {

          }
        })
        .catch(err => {
          this.showMessageBox(err, "Failed", "danger");
        });
    },
    addUser() {
      if(this.inputData.email && this.inputData.name) {
        this.showLoading = true;
        var payload = {
          name: this.inputData.name,
          email: this.inputData.email,
          nis: this.inputData.nis
        }

        this.userCreate(payload)
          .then(response => {
            this.showLoading = false;
            this.addModal = false;
            this.getUserList();
            this.showMessageBox("Data has been saved", "Success", "success");
          })
          .catch(error => {
            this.showLoading = false;
            this.showMessageBox(error, "Failed", "danger");
          });
      } else {
        this.showMessageBox("Please fill name and email first", "Empty Data", "warning");
      }
    },
    editUser() {
      if(this.inputData.mailing_email && this.inputData.name) {
        this.showLoading = true;
        var payload = {
          id: this.inputData.id,
          name: this.inputData.name,
          mailing_email: this.inputData.mailing_email,
          nis: this.inputData.nis
        }

        this.userUpdate(payload)
          .then(response => {
            this.showLoading = false;
            this.addModal = false;
            this.getUserList();
            this.showMessageBox("Data has been saved", "Success", "success");
          })
          .catch(error => {
            this.showLoading = false;
            this.showMessageBox(error, "Failed", "danger");
          });
      } else {
        this.showMessageBox("Please fill name and mailing email first", "Empty Data", "warning");
      }
    },
    editUserEmail() {
      if(this.inputData.email) {
        this.showLoading = true;
        var payload = {
          id: this.inputData.id,
          email: this.inputData.email
        }

        this.userUpdateEmail(payload)
          .then(response => {
            this.showLoading = false;
            this.addModal = false;
            this.getUserList();
            this.showMessageBox("Data has been saved", "Success", "success");
          })
          .catch(error => {
            this.showLoading = false;
            this.showMessageBox(error, "Failed", "danger");
          });
      } else {
        this.showMessageBox("Please fill email first", "Empty Data", "warning");
      }
    },
    showMessageBox(message, title, variant) {
      this.$bvModal
        .msgBoxOk(message, {
          title: title,
          size: "sm",
          buttonSize: "sm",
          okVariant: variant,
          centered: true
        })
        .then(value => {
        })
        .catch(err => {
        });
    }
  }
};
</script>

<style>
.search-wrapper {
  width: 100%;
  max-width: 222px;
}

.filter-icon {
  margin-right: 11px;
  background-color: #e9e9e9;
  width: 32px;
  height: 32px;
  border-radius: 32px;
  text-align: center;
  padding-top: 7px;
}

.action-button:hover {
  background-color: #f08045;
  border: 1px solid #f08045;
}
</style>